module.exports = {"id":"216283","name":"Danilo","rating":"71","photo":"./data/images/photos/0/216283.png","club":{"name":"VfL Bochum","logo":"./data/images/clubs/VfLBochum.png"},"positions":["DG","DLG","DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Danilo0.json
// module id = 955
// module chunks = 0